import { graphql } from 'react-relay';

export const detailFilterListCategoryFragment = graphql`
    fragment DetailFilterListCategory_category on DetailFilterListCategory {
        col
        categoryname
        info {
            ...CategoryInfo_info
        }
        filteritems {
            label
            filtervalue
        }
    }
`;
